import { HttpClient } from '@angular/common/http';
import { AfterContentInit, Component } from '@angular/core';
import { Config } from '../Config';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-bridge-conditions-report',
  templateUrl: './bridge-conditions-report.component.html',
  styleUrls: ['./bridge-conditions-report.component.css']
})
export class BridgeConditionsReportComponent implements AfterContentInit {

  public config = (window as any).config as Config;

  aoiType: 'state' | 'district' | 'county' | 'houseDistrict' | 'congressionalDistrict' | 'senateDistrict' | 'planningPartner' | 'municipality';
  aoiDisplayName: string;
  aoiValue: { value: string, display: string } = { value: '', display: '' };
  categories: { categoryName: string, stateLocal: string, count: number, isOpen: boolean }[] = [];
  reportData: IReportData[] = [];
  rawReportData: IReportData[] = [];
  totalBridges: number;
  legislatorData: ILegislatorData;
  sort = 'brKey';
  sortReverse = true;
  isLoading: boolean;

  constructor(private http: HttpClient) {
  }

  ngAfterContentInit() {
    this.parseURL();
    this.getReportData();
  }



  async parseURL() {
    const url = window.location.href;

    if (url.includes('aoiType=state')) {
      this.aoiType = 'state';
      this.aoiDisplayName = 'Statewide';
      this.aoiValue.value = 'state';

    } else if (url.includes('dist=')) {
      this.aoiType = 'district';
      this.aoiDisplayName = 'District';
      const index = url.indexOf('dist=') + 'dist='.length;
      this.aoiValue.value = url.substring(index, index + 2);
      this.aoiValue.display = url.substring(index, index + 2);
    } else if (url.includes('cn=')) {
      if (url.includes('muni=')) {
        this.aoiType = 'municipality';
        this.aoiDisplayName = 'Municipality';
        let index = url.indexOf('cn=') + 'cn='.length;
        const countyValue = url.substring(index, index + 2);
        index = url.indexOf('muni=') + 'muni='.length;
        const muniValue = url.substring(index, url.length);
        this.aoiValue.display = countyValue + ' | ' + muniValue;
        this.aoiValue.value = countyValue + muniValue;
      } else {
        this.aoiType = 'county';
        this.aoiDisplayName = 'County';
        const index = url.indexOf('cn=') + 'cn='.length;
        this.aoiValue.value = url.substring(index, index + 2);
        // county aoiValue.display populated after report request returns
      }
    } else if (url.includes('houseDistrictNumber=')) {
      this.aoiType = 'houseDistrict';
      this.aoiDisplayName = 'Legislative House';
      const index = url.indexOf('houseDistrictNumber=') + 'houseDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName
                              + ' (' + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('congressDistrictNumber=')) {
      this.aoiType = 'congressionalDistrict';
      this.aoiDisplayName = 'Legislative Congress';
      const index = url.indexOf('congressDistrictNumber=') + 'congressDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName + ' ('
                              + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('senateDistrictNumber=')) {
      this.aoiType = 'senateDistrict';
      this.aoiDisplayName = 'Legislative Senate';
      const index = url.indexOf('senateDistrictNumber=') + 'senateDistrictNumber='.length;
      this.aoiValue.value = url.substring(index, url.length);
      await this.getLegislatorData();
      this.aoiValue.display = this.aoiValue.value + ' - ' + this.legislatorData.firstName + ' ' + this.legislatorData.lastName + ' ('
                              + this.legislatorData.party + ') - ' + this.legislatorData.homeCounty + ' County';
    } else if (url.includes('mporpo=')) {
      this.aoiType = 'planningPartner';
      this.aoiDisplayName = 'Planning Partner';
      const index = url.indexOf('mporpo=') + 'mporpo='.length;
      this.aoiValue.display = url.substring(index, url.length);
      this.aoiValue.value = url.substring(index, url.length);
    }
  }

  async getReportData() {
    this.isLoading = true;
    let requestURL = 'api/reports/';
    let type: string = this.aoiType;
    if (this.aoiType === 'state') {
      type = 'statewide';
    } else if (this.aoiType === 'houseDistrict') {
      type = 'legislativehouse';
    } else if (this.aoiType === 'senateDistrict') {
      type = 'legislativesenate';
    } else if (this.aoiType === 'congressionalDistrict') {
      type = 'legislativecongress';
    }

    requestURL += 'GetBridgeConditionsReportData?aoiType=' + type + '&aoiValue=' + this.aoiValue.value;

    try {
      this.rawReportData = await this.http.get<IReportData[]>(requestURL).toPromise();
    } catch (error) {
      console.error('Error', error);
    } finally {
      if (this.aoiType === 'county') {
        let index = 0;
        while (true) {
          if (this.rawReportData[index].countyName !== '') {
            break;
          }
          index++;
        }
        this.aoiValue.display = this.rawReportData[index].countyName.trim().toUpperCase() + ' (' + this.aoiValue.value + ')';
      }
      this.totalBridges = this.rawReportData.length;

      for (const bridge of this.rawReportData) {
        let categoryName = bridge.stateLocal === 'S' ? 'State Bridges - ' : 'Local Bridges - ';
        categoryName += bridge.condition + ' Condition';
        bridge.categoryName = categoryName;
        if (!(this.categories.findIndex(c => c.categoryName === bridge.categoryName) >= 0)) {
          this.categories.push({ categoryName: categoryName, stateLocal: bridge.stateLocal, count: 1, isOpen: false });
        } else {
          const index = this.categories.findIndex(c => c.categoryName === bridge.categoryName);
          this.categories[index].count++;
        }
      }
      this.categories = this.categories.sort((c1, c2) => {
        const c1IsState = c1.categoryName.includes('State');
        const c2IsState = c2.categoryName.includes('State');
        if ((c1IsState && c2IsState) || (!c1IsState && !c2IsState)) {
          const c1Condition = c1.categoryName.split(' ')[3];
          const c2Condition = c2.categoryName.split(' ')[3];
          if (c1Condition === 'Good') {
            return -1;
          }
          if (c2Condition === 'Good') {
            return 1;
          }
          if (c1Condition === 'Fair') {
            return -1;
          }
          if (c2Condition === 'Fair') {
            return 1;
          }
        } else if (c1IsState && !c2IsState) {
          return -1;
        } else if (!c1IsState && c2IsState) {
          return 1;
        }
      });
    }
    this.reportData = this.rawReportData;
    this.isLoading = false;
  }

  async getLegislatorData() {
    const requestURL = 'api/reports/GetDistrictLegislator?districtType=' + this.aoiType + '&districtValue=' + this.aoiValue.value;

    try {
      this.legislatorData = await this.http.get<ILegislatorData>(requestURL).toPromise();
    } catch (error) {
      console.error('Error', error);
    }
  }

  toggleCategory(index: number) {
    this.categories[index].isOpen = !this.categories[index].isOpen;
  }

  exportToCSV() {
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    let worksheet: XLSX.WorkSheet;
    const name = 'BridgeConditionReport_';

    worksheet = XLSX.utils.json_to_sheet(this.reportData);
    const wbName = (name + this.aoiDisplayName).substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, wbName);

    const currentDate: Date = new Date();
    const formattedDate: string = currentDate.toISOString().slice(0, 10).replace(/-/g, '_');
    XLSX.writeFile(workbook, name + this.aoiDisplayName + '-' + this.aoiValue.value + '_' + formattedDate + '.xlsx');
  }

  sortBy(sortType: string) {
    if (sortType === this.sort) {
      this.sortReverse = !this.sortReverse;
    }
    this.sort = sortType;

     this.reportData = this.reportData.sort((a, b) => {
      if (this.sort === 'brKey') {
        if (this.sortReverse) {
          return a.brKey - b.brKey;
        } else {
          return b.brKey - a.brKey;
        }
      } else if (this.sort === 'bridgeId') {
        if (this.sortReverse) {
          return parseInt(a.bridgeId, 10) - parseInt(b.bridgeId, 10);
        } else {
          return parseInt(b.bridgeId, 10) - parseInt(a.bridgeId, 10);
        }
      } else if (this.sort === 'county') {
        if (this.sortReverse) {
          return a.countyName.trim() <= b.countyName.trim() ? -1 : 1;
        } else {
          return b.countyName.trim() < a.countyName.trim() ? -1 : 1;
        }
      } else if (this.sort === 'muni') {
        if (this.sortReverse) {
          return a.municipalityName.trim() <= b.municipalityName.trim() ? -1 : 1;
        } else {
          return b.municipalityName.trim() < a.municipalityName.trim() ? -1 : 1;
        }
      } else if (this.sort === 'location') {
        if (this.sortReverse) {
          return a.location.trim() <= b.location.trim() ? -1 : 1;
        } else {
          return b.location.trim() < a.location.trim() ? -1 : 1;
        }
      } else if (this.sort === 'facility') {
        if (this.sortReverse) {
          return a.facility.trim() <= b.facility.trim() ? -1 : 1;
        } else {
          return b.facility.trim() < a.facility.trim() ? -1 : 1;
        }
      } else if (this.sort === 'featint') {
        if (this.sortReverse) {
          return a.featInt.trim() <= b.featInt.trim() ? -1 : 1;
        } else {
          return b.featInt.trim() < a.featInt.trim() ? -1 : 1;
        }
      } else if (this.sort === 'owner') {
        if (this.sortReverse) {
          return a.ownerDescription.trim() <= b.ownerDescription.trim() ? -1 : 1;
        } else {
          return b.ownerDescription.trim() < a.ownerDescription.trim() ? -1 : 1;
        }
      } else if (this.sort === 'length') {
        if (this.sortReverse) {
          return a.bridgeLength - b.bridgeLength;
        } else {
          return b.bridgeLength - a.bridgeLength;
        }
      } else if (this.sort === 'deckArea') {
        if (this.sortReverse) {
          return a.deckArea - b.deckArea;
        } else {
          return b.deckArea - a.deckArea;
        }
      } else if (this.sort === 'numberOfSpans') {
        if (this.sortReverse) {
          return a.mainSpans - b.mainSpans;
        } else {
          return b.mainSpans - a.mainSpans;
        }
      } else if (this.sort === 'material') {
        if (this.sortReverse) {
          return a.mainMaterial.trim() <= b.mainMaterial.trim() ? -1 : 1;
        } else {
          return b.mainMaterial.trim() < a.mainMaterial.trim() ? -1 : 1;
        }
      } else if (this.sort === 'strutureType') {
        if (this.sortReverse) {
          return a.mainStructure.trim() <= b.mainStructure.trim() ? -1 : 1;
        } else {
          return b.mainStructure.trim() < a.mainStructure.trim() ? -1 : 1;
        }
      } else if (this.sort === 'yearBuilt') {
        if (this.sortReverse) {
          return a.yearBuilt.trim() <= b.yearBuilt.trim() ? -1 : 1;
        } else {
          return b.yearBuilt.trim() < a.yearBuilt.trim() ? -1 : 1;
        }
      } else if (this.sort === 'postingStatus') {
        if (this.sortReverse) {
          return a.postStatusDescription.trim() <= b.postStatusDescription.trim() ? -1 : 1;
        } else {
          return b.postStatusDescription.trim() < a.postStatusDescription.trim() ? -1 : 1;
        }
      } else if (this.sort === 'weightLimitSingle') {
        if (this.sortReverse) {
          return a.postLimitWeight - b.postLimitWeight;
        } else {
          return b.postLimitWeight - a.postLimitWeight;
        }
      } else if (this.sort === 'weightLimitCombo') {
        if (this.sortReverse) {
          return a.postLimitCombo - b.postLimitCombo;
        } else {
          return b.postLimitCombo - a.postLimitCombo;
        }
      } else if (this.sort === 'deckCondition') {
        const aFirstChar = a.deckRating.charAt(0) === 'N' ? '0' : a.deckRating.charAt(0);
        const bFirstChar = b.deckRating.charAt(0) === 'N' ? '0' : b.deckRating.charAt(0);
        if (this.sortReverse) {
          return parseInt(aFirstChar, 10) - parseInt(bFirstChar, 10);
        } else {
          return parseInt(bFirstChar, 10) - parseInt(aFirstChar, 10);
        }
      } else if (this.sort === 'superCondition') {
        const aFirstChar = a.supRating.charAt(0) === 'N' ? '0' : a.supRating.charAt(0);
        const bFirstChar = b.supRating.charAt(0) === 'N' ? '0' : b.supRating.charAt(0);
        if (this.sortReverse) {
          return parseInt(aFirstChar, 10) - parseInt(bFirstChar, 10);
        } else {
          return parseInt(bFirstChar, 10) - parseInt(aFirstChar, 10);
        }
      } else if (this.sort === 'subCondition') {
        const aFirstChar = a.subRating.charAt(0) === 'N' ? '0' : a.subRating.charAt(0);
        const bFirstChar = b.subRating.charAt(0) === 'N' ? '0' : b.subRating.charAt(0);
        if (this.sortReverse) {
          return parseInt(aFirstChar, 10) - parseInt(bFirstChar, 10);
        } else {
          return parseInt(bFirstChar, 10) - parseInt(aFirstChar, 10);
        }
      } else if (this.sort === 'culvCondition') {
        const aFirstChar = a.culvRating.charAt(0) === 'N' ? '0' : a.culvRating.charAt(0);
        const bFirstChar = b.culvRating.charAt(0) === 'N' ? '0' : b.culvRating.charAt(0);
        if (this.sortReverse) {
          return parseInt(aFirstChar, 10) - parseInt(bFirstChar, 10);
        } else {
          return parseInt(bFirstChar, 10) - parseInt(aFirstChar, 10);
        }
      } else if (this.sort === 'planningPartner') {
        if (this.sortReverse) {
          return a.planningPartnerShortName.trim() <= b.planningPartnerShortName.trim() ? -1 : 1;
        } else {
          return b.planningPartnerShortName.trim() < a.planningPartnerShortName.trim() ? -1 : 1;
        }
      } else if (this.sort === 'averageDailyTraffic') {
        if (this.sortReverse) {
          return a.adtTotal - b.adtTotal;
        } else {
          return b.adtTotal - a.adtTotal;
        }
      }
     });
  }
}

interface IReportData {
  stateLocal: string;
  condition: string;
  brKey: number;
  bridgeId: string;
  countyName: string;
  municipalityName: string;
  location: string;
  facility: string;
  featInt: string;
  postStatusDescription: string;
  districtnumber: string;
  countyCode: string;
  houseDistricts: string;
  senateDistricts: string;
  congressDistricts: string;
  planningPartnerShortName: string;
  countyMunicipalityCodes: string;
  ownerDescription: string;
  bridgeLength: number;
  deckArea: number;
  mainSpans: number;
  mainMaterial: string;
  mainStructure: string;
  yearBuilt: string;
  postLimitWeight: number;
  postLimitCombo: number;
  deckRating: string;
  supRating: string;
  subRating: string;
  culvRating: string;
  adtTotal: number;
  stateRoute: string;
  categoryName: string;
}
interface ILegislatorData {
  firstName: string;
  lastName: string;
  party: string;
  homeCounty: string;
}
